module.exports = __webpack_public_path__ + "img/billboard_2.7f5550e2.svg";